module.exports = __webpack_public_path__ + "assets/img/tx120_3.0d64a4d1.jpg";